(function () {
  if (window.__clpProductMediaBootstrap) return;
  window.__clpProductMediaBootstrap = true;

  function executeInline(source) {
    if (!source || source.dataset.clpBootstrapExecuted === 'true') return;
    source.dataset.clpBootstrapExecuted = 'true';
    var runner = document.createElement('script');
    runner.text = source.textContent;
    document.head.appendChild(runner);
    runner.remove();
  }

  function scan() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var scripts = main.querySelectorAll('script:not([src])');

    if (!window.__clpMediumLinks && document.querySelector('.clp-medium-links')) {
      Array.prototype.some.call(scripts, function (script) {
        if (script.textContent.indexOf('window.__clpMediumLinks = true') === -1) return false;
        executeInline(script);
        return true;
      });
    }

    var frameRoot = document.getElementById('FramePick');
    if (frameRoot && !frameRoot.__init) {
      Array.prototype.forEach.call(scripts, function (script) {
        var code = script.textContent;
        if (code.indexOf('root.__init = true') !== -1 || code.indexOf('var LB_CORNER =') !== -1) {
          executeInline(script);
        }
      });
    }
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queueScan);
})();
